module.exports = __webpack_public_path__ + "static/assets/bd5c9d7a0e3d859df04ae57751fa950b.svg";